import { isFullScreen } from '../fullscreen/fullscreen_utils';

export function inAnIFrame() {
  return window.location !== window.parent.location;
}

/**
 * Determines if the application is embedded within other content.
 * This is true when the application is in an iframe and not in fullscreen mode.
 */
export function isEmbedded(): boolean {
  return inAnIFrame() && !isFullScreen(document);
}
